import axios from 'axios'
import {
    Message
} from 'element-ui'
import { proxyUrl } from "./config";
const service = axios.create({
    baseURL: proxyUrl,
    timeout: 10000,
})
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
service.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.code == 1||res.code == 200||res.status == 200||res.urls) {
            return res
        } else {
            Message.error(res.msg || '请求出错')
            return Promise.reject(new Error(res.msg || 'Error'))
        }
    },
    error => {
        let message = ''
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    message = '身份认证失败，请重新登录'
                    break
                case 403:
                    message = '拒绝访问'
                    break
                case 404:
                    message = '资源不存在'
                    break
                default:
                    message = `网络错误 (${error.response.status})`
            }
        } else if (error.message.includes('timeout')) {
            message = '请求超时'
        } else {
            message = '网络连接异常'
        }
        Message.error(message)
        return Promise.reject(error)
    }
)
export function request(config) {
    return service(config)
}
export function get(url, params) {
    return service.get(url, params)
}
export function post(url, data) {
    return service.post(url, data)
}